import { instanceApi } from '../../services';
import { ResetPassword } from './RepresentativeSignUpModel';

export const resetPassword = (resetPass: ResetPassword): any => instanceApi.post('auth/Users/ResetPassword', resetPass);
